import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const createLeadProposal = (_, params) => {
  return Api(endPoints.createLeadProposal, params, requestType.POST);
};

const getAllLeadProposal = (params = {}) => {
  const url = endPoints.getAllLeadProposalByAgendId;
  const queryParams = new URLSearchParams();

  if (params.page) {
    queryParams.append("page", params.page);
  }
  if (params.limit) {
    queryParams.append("limit", params.limit);
  }
  if (params.search?.trim()) {
    queryParams.append("search", params.search);
  }

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const getAllLeadProposalByAgendId = (id, params) => {
  const url = `${endPoints.getAllLeadProposalByAgendId}/${id}`;
  const queryParams = new URLSearchParams();

  if (params.page) {
    queryParams.append("page", params.page);
  }
  if (params.limit) {
    queryParams.append("limit", params.limit);
  }
  if (params.search?.trim()) {
    queryParams.append("search", params.search);
  }
  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const updateLeadProposal = (id, params) => {
  return Api(`${endPoints.updateLeadProposal}/${id}`, params, requestType.PUT);
};

const updateLeadAndResendProposal = (id, params) => {
  return Api(
    `${endPoints.updateLeadAndResendProposal}/${id}`,
    params,
    requestType.PUT,
  );
};

const getContractEndDateCount = (startDate = "", endDate = "") => {
  const url = `${endPoints.contractEndDateCount}?startDate=${startDate}&endDate=${endDate}`;
  return Api(url, null, requestType.GET);
};

const getAllMeetingDetails = (ids = []) => {
  const url =
    ids.length > 0
      ? `${endPoints.getAllMeetingDetails}?agentId=${ids.join(",")}`
      : endPoints.getAllMeetingDetails;

  return Api(url, null, requestType.GET);
};

const exportMeetingLeads = () => {
  return Api(endPoints.exportMeetingLeads, null, requestType.GET);
};

export {
  createLeadProposal,
  getAllLeadProposalByAgendId,
  updateLeadProposal,
  updateLeadAndResendProposal,
  getContractEndDateCount,
  getAllLeadProposal,
  getAllMeetingDetails,
  exportMeetingLeads,
};
